import React from "react";
import { Formik, Field, FieldArray, Form } from "formik";
import { Row, Col, Label, Input } from "reactstrap";

const ExperienceForm = () => {
  return (
    <Formik
      initialValues={{
        experiences: [
          {
            jobTitle: "",
            companyName: "",
            fromYear: "",
            toYear: "",
            jobDescription: ""
          }
        ]
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({ values }) => (
        <Form>
          <FieldArray name="experiences">
            {({ push, remove }) => (
              <>
                {values.experiences.map((exp, index) => (
                  <div key={index} className="border rounded p-3 mb-3">

                    {/* Job Title */}
                    <Row>
                      <Col lg={12}>
                        <div className="mb-3">
                          <Label className="form-label">Job Title</Label>
                          <Field
                            name={`experiences.${index}.jobTitle`}
                            as={Input}
                            placeholder="Job title"
                          />
                        </div>
                      </Col>

                      {/* Company Name */}
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">Company Name</Label>
                          <Field
                            name={`experiences.${index}.companyName`}
                            as={Input}
                            placeholder="Company name"
                          />
                        </div>
                      </Col>

                      {/* From–To Year */}
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">Experience Years</Label>

                          <Row>
                            <Col lg={5}>
                              <Field
                                as="select"
                                className="form-control"
                                name={`experiences.${index}.fromYear`}
                              >
                                <option value="">Select years</option>
                                {Array.from({ length: 22 }, (_, i) => 2001 + i).map((yr) => (
                                  <option key={yr} value={yr}>{yr}</option>
                                ))}
                              </Field>
                            </Col>

                            <div className="col-auto align-self-center">to</div>

                            <Col lg={5}>
                              <Field
                                as="select"
                                className="form-control"
                                name={`experiences.${index}.toYear`}
                              >
                                <option value="">Select years</option>
                                {Array.from({ length: 22 }, (_, i) => 2001 + i).map((yr) => (
                                  <option key={yr} value={yr}>{yr}</option>
                                ))}
                              </Field>
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      {/* Job Description */}
                      <Col lg={12}>
                        <div className="mb-3">
                          <Label className="form-label">Job Description</Label>
                          <Field
                            name={`experiences.${index}.jobDescription`}
                            as="textarea"
                            className="form-control"
                            rows="3"
                            placeholder="Enter job description"
                          />
                        </div>
                      </Col>

                      {/* Delete Button */}
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => remove(index)}
                        >
                          Delete
                        </button>
                      </div>
                    </Row>
                  </div>
                ))}

                {/* Add New Button */}
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  onClick={() =>
                    push({
                      jobTitle: "",
                      companyName: "",
                      fromYear: "",
                      toYear: "",
                      jobDescription: ""
                    })
                  }
                >
                  Add New
                </button>
              </>
            )}
          </FieldArray>

          {/* Submit Button */}
          <button type="submit" className="btn btn-success">Update</button>
        </Form>
      )}
    </Formik>
  );
};

export default ExperienceForm;
